import { Dropdown, Menu } from "antd"
import BugReportModal from "Components/modals/bugReport.modal"
import UserImage from "Components/UserImage"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { useLoggedInEmployeeProfile } from "Shared/hooks/user.hooks"
import { logout } from "Shared/store/actions/auth/authActions"
import { MenuItemInterface, NavbarMenuItemEnum } from "./types"
import { getPopupAnchor } from "Shared/utils"
import { isDev, isInternal } from "Shared/utils/helpers"
import { useModal } from "Shared/context/modal.context"
import SimulatorModal from "Components/modals/simulator/simulator.modal"
import { setHasLoaded, setLoading } from "Shared/store/actions/fetcher/fetcherActions"

const UserProfileNavbar: React.FC = () => {
    const history = useHistory()
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { showModal } = useModal()

    const [isBugReportShowing, setIsBugReportShowing] = useState(false)

    const loggedInEmployeeProfile = useLoggedInEmployeeProfile()

    const userMenuItems: MenuItemInterface[] = [
        {
            link: "settings",
            label: t("nav:settings"),
        },
        {
            link: "logout",
            label: t("nav:logout"),
        },
    ]

    const handleUserMenuCommand = async (command: string) => {
        switch (command) {
            case NavbarMenuItemEnum.LOGOUT:
                await dispatch(setLoading())
                await dispatch(logout())
                await dispatch(setHasLoaded())
                history.push("/login")
                break
            default:
                history.push("/" + command)
        }
    }

    return (
        <>
            <BugReportModal isVisible={isBugReportShowing} onCancel={setIsBugReportShowing} />
            {loggedInEmployeeProfile && (
                <Dropdown
                    getPopupContainer={getPopupAnchor()}
                    className={"flex items-center"}
                    trigger={["click"]}
                    overlay={
                        <Menu className="z-20 user-dropdown">
                            <div className="flex mr-20 ml-10 pt-8 pb-8 mb-10 border-b">
                                <UserImage user={loggedInEmployeeProfile} size="large" />
                                <div className="flex flex-col justify-center">
                                    <span className="text-base text-text-dark font-bold leading-none truncate">{loggedInEmployeeProfile.getFullName()}</span>
                                    <span className="text-sm truncate max-w-200">{loggedInEmployeeProfile.email}</span>
                                </div>
                            </div>
                            {(isDev || isInternal) && <Menu.Item onClick={() => showModal(SimulatorModal, false, { isShowing: true })}>{t("label:simulator")}</Menu.Item>}
                            {userMenuItems.map(({ link, label }: MenuItemInterface, index: number) => (
                                <Menu.Item key={index} onClick={() => handleUserMenuCommand(link)}>
                                    {label}
                                </Menu.Item>
                            ))}
                        </Menu>
                    }
                >
                    <div className="w-full cursor-pointer">
                        <UserImage user={loggedInEmployeeProfile} size="large" />
                    </div>
                </Dropdown>
            )}
        </>
    )
}

export default UserProfileNavbar
